const PERMISSIONS = {
  CREATE_PAGE: 'page.create',
  EDIT_PAGE: 'page.edit',
  DELETE_PAGE: 'page.delete',
  CREATEEDIT_BLOG: 'blog.createedit',
  DELETE_BLOG: 'blog.delete',
  CREATEEDIT_PODCAST: 'podcast.createedit',
  DELETE_PODCAST: 'podcast.delete',
  CREATEEDIT_FORM: 'form.createedit',
  DELETE_FORM: 'form.delete',
  CREATEEDIT_MENU: 'menu.createedit',
  DELETE_MENU: 'menu.delete',
  RESET_STATS: 'stats.reset',
  EDIT_METAINFO: 'metainfo.edit',
  EDIT_BUSINESSINFO: 'businessinfo.edit',
  EDIT_CUSTOMURL: 'customurl.edit',
  EDIT_PROMPTS: 'prompt.edit',
  EDIT_CUSTOMSCRIPTS: 'customscripts.edit',
  EDIT_PRIVACYTERMS: 'privacyterms.edit',
  CREATEEDIT_WEBHOOK: 'webhook.createedit',
  DELETE_WEBHOOK: 'webhook.delete',
  DELETE_CONTACT: 'contact.delete',
  CREATEEDIT_REDIRECT: 'redirect.createedit',
  DELETE_REDIRECT: 'redirect.delete',
  CREATEEDIT_BACKUP: 'backup.createedit',
  DELETE_BACKUP: 'backup.delete',
  CREATEEDIT_INTEGRATION: 'integration.createedit',
  DELETE_INTEGRATION: 'integration.delete',
  CREATEEDIT_GATEWAY: 'gateway.createedit',
  DELETE_GATEWAY: 'gateway.delete',
  CREATEEDIT_PRODUCT: 'product.createedit',
  DELETE_PRODUCT: 'product.delete',
  CREATE_COUPON: 'coupon.create',
  DELETE_COUPON: 'coupon.delete',
  CANCEL_SUBSCRIPTION: 'subscription.cancel',
  CREATEEDIT_CARD: 'card.createedit',
  DELETE_CARD: 'card.delete',
  TRANSFER_CARD: 'card.transfer',
}
const NO_PERMISSION_MESSAGE = 'You do not have permission to access this feature, please contact the admin.'

export {
  PERMISSIONS,
  NO_PERMISSION_MESSAGE
}